module.exports = __webpack_public_path__ + "img/recommed-img7.68cb7525.jpg";